export const convertDateToTimeRangeFormat = ({
  from,
  to,
}: {
  from: number
  to: number
}) => ({
  from: new Date(from),
  to: new Date(to),
})
